/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Online_HintInputs */

const en_directory_search_online_hint = /** @type {(inputs: Directory_Search_Online_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From anywhere, over video`)
};

const pl_directory_search_online_hint = /** @type {(inputs: Directory_Search_Online_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skądkolwiek, przez wideo`)
};

/**
* | output |
* | --- |
* | "From anywhere, over video" |
*
* @param {Directory_Search_Online_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_online_hint = /** @type {((inputs?: Directory_Search_Online_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Online_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_online_hint(inputs)
	return en_directory_search_online_hint(inputs)
});